import { VesselPosition } from '../../../../lib/vessels/registries/vessels.types';

export const getUniqueVesselKey = (vesselPosition: VesselPosition): string => {
	const { vessel, location } = vesselPosition;
	return `${vessel.name}_${location.latitude}_${location.longitude}_${location.destination}_${location.reportedAT}`;
};
